"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIMiniReportResponseSchema = exports.APIMiniReportMetricSchema = exports.APIMiniReportRequestSchema = exports.APIScanInsightsResponseSchema = exports.APIScanInsightsMetricSchema = exports.APIScanInsightsRequestSchema = exports.APIMetricDashboardRegionalLandmarksResponseSchema = exports.APIMetricDashboardRegionalLandmarksItemSchema = exports.APIMetricDashboardRegionalLandmarksRequestSchema = exports.APIMetricDashboardRegionalDeepDiveResponseV2Schema = exports.APIMetricDashboardRegionalChartDataV2Schema = exports.APIMetricDashboardRegionalDeepDiveResponseSchema = exports.APIMetricDashboardRegionalChartDataSchema = exports.APIMetricDashboardRegionalDeepDiveRequestSchema = exports.APIMetricDashboardDeepDiveResponseV2Schema = exports.APIMetricDashboardDeepDiveObjectV2Schema = exports.APIMetricDashboardDeepDiveValueV2Schema = exports.APIMetricDashboardDeepDiveResponseSchema = exports.APIMetricDashboardDeepDiveObjectSchema = exports.APIMetricDashboardDeepDiveValueSchema = exports.APIMetricDashboardRegionalDataSchema = exports.FaceLandmarkSchema = exports.APIMetricDashboardDeepDiveDefinitionSchema = exports.APIMetricDashboardDeepDiveImageQualitySchema = exports.APIMetricDashboardDeepDiveRequestSchema = exports.APIMetricDashboardFavoriteMetricsResponseSchema = exports.APIMetricDashboardFavoriteMetricsRequestSchema = exports.APIMetricDashboardResponseSchema = exports.APIMetricDashboardMetricSchema = exports.APIMetricDashboardScanRecommendationSchema = exports.APIMetricDashboardRequestSchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("./enums");
// ===== SCHEMAS =====
exports.APIMetricDashboardRequestSchema = zod_1.z.object({}).nullish();
exports.APIMetricDashboardScanRecommendationSchema = zod_1.z.object({
    currentLevel: zod_1.z.number(),
    adjustedLevel: zod_1.z.number(),
    deteriorationInfo: zod_1.z.object({
        daysSinceLastScan: zod_1.z.number(),
        deteriorationFactor: zod_1.z.number(),
        halfLifesCrossed: zod_1.z.number(),
    }),
    nextLevelRequirement: zod_1.z
        .object({
        scansNeeded: zod_1.z.number(),
        withinDays: zod_1.z.number(),
    })
        .nullish(),
    strengthDropDate: zod_1.z.string().nullable(),
    optimalScanInterval: zod_1.z.number(),
    urgency: zod_1.z.enum(['low', 'medium', 'high', 'critical']),
});
exports.APIMetricDashboardMetricSchema = zod_1.z.object({
    class: zod_1.z.enum(enums_1.metricClassEnum), // fast, medium, slow, ultra_slow
    techName: zod_1.z.enum(enums_1.techNameEnum), // tech name of the metric
    area: zod_1.z.enum(enums_1.areaEnum), // area of the metric
    supportsDeepDive: zod_1.z.boolean(), // true if the metric supports deep dive insights
    current: zod_1.z
        .object({
        state: zod_1.z.enum(enums_1.metricStateEnum), // instant or trend
        type: zod_1.z.enum(enums_1.metricValueTypeEnum), // numeric or categorical
        nEff: zod_1.z.number(), // number of effective scans
        numeric: zod_1.z.number().nullish(), // numeric value
        categorical: zod_1.z.string().nullish(), // categorical value
        rating: zod_1.z.enum(enums_1.metricRatingEnum).nullish(), // Excellent, Good, Average, Needs Improvement
        confidenceScore: zod_1.z.number().nullish(), // Confidence score
    })
        .nullish(),
    baseline: zod_1.z
        .object({
        locked: zod_1.z.boolean(), // true if the baseline is locked
        unlockRequirements: zod_1.z
            .object({
            scansNeeded: zod_1.z.number(), // number of scans to unlock the baseline
            withinDays: zod_1.z.number(), // number of days to unlock the baseline
        })
            .nullish(),
        values: zod_1.z.array(zod_1.z.object({
            ema: zod_1.z.number().nullish(), // EMA value
            emaConfidenceScore: zod_1.z.number().nullish(), // Confidence score of the EMA value
            baselineEma: zod_1.z.number().nullish(), // Baseline EMA value
            baselineMethod: zod_1.z.enum(enums_1.baselineMethodEnum).nullish(), // Baseline method
            baselineConfidenceScore: zod_1.z.number().nullish(), // Baseline confidence score
            pctChange: zod_1.z.number(), // Percentage change between current and baseline
            scanAt: zod_1.z.string(), // scan date
        })),
    })
        .nullish(),
});
exports.APIMetricDashboardResponseSchema = zod_1.z.object({
    metrics: zod_1.z.array(exports.APIMetricDashboardMetricSchema),
    hasScannedToday: zod_1.z.boolean(), // Whether user has already scanned today
});
exports.APIMetricDashboardFavoriteMetricsRequestSchema = zod_1.z
    .object({})
    .nullish();
exports.APIMetricDashboardFavoriteMetricsResponseSchema = zod_1.z.array(zod_1.z.enum(enums_1.techNameEnum));
exports.APIMetricDashboardDeepDiveRequestSchema = zod_1.z
    .object({
    locale: zod_1.z.enum(enums_1.supportedLocaleEnum),
})
    .nullish();
exports.APIMetricDashboardDeepDiveImageQualitySchema = zod_1.z
    .object({
    overallScore: zod_1.z.number(),
    qualityResult: zod_1.z
        .object({
        metricWeight: zod_1.z.number(),
        meetsThreshold: zod_1.z.boolean(),
        qualityFactors: zod_1.z.record(zod_1.z.string(), zod_1.z.number()),
    })
        .nullish(),
})
    .nullish();
exports.APIMetricDashboardDeepDiveDefinitionSchema = zod_1.z.object({
    whatIsIt: zod_1.z.string(),
    howWeMeasure: zod_1.z.array(zod_1.z.string()),
    improvesWith: zod_1.z.array(zod_1.z.string()),
    worsensWith: zod_1.z.array(zod_1.z.string()),
});
exports.FaceLandmarkSchema = zod_1.z.object({
    x: zod_1.z.number(),
    y: zod_1.z.number(),
    z: zod_1.z.number(),
});
exports.APIMetricDashboardRegionalDataSchema = zod_1.z.object({
    area: zod_1.z.enum(enums_1.areaEnum),
    ema: zod_1.z.number().nullish(),
    emaFast: zod_1.z.number().nullish(),
    baselineEma: zod_1.z.number().nullish(),
    /**
     * Legacy single-anchor field for backward compatibility with clients that
     * pre-date bilateral overlay support. New responses populate both fields;
     * renderers should prefer `landmarks` when present and fall back here.
     */
    landmark: exports.FaceLandmarkSchema.nullish(),
    /**
     * Bilateral / multi-anchor support: dermatologist-flagged metrics may
     * place a single regional score on multiple anatomical points (e.g.,
     * bilateral nasolabial folds, both jowls). One or more points.
     */
    landmarks: exports.FaceLandmarkSchema.array().optional(),
    insight: zod_1.z.string().nullish(),
});
exports.APIMetricDashboardDeepDiveValueSchema = zod_1.z.object({
    techName: zod_1.z.enum(enums_1.techNameEnum),
    area: zod_1.z.enum(enums_1.areaEnum),
    scanRecommendation: exports.APIMetricDashboardScanRecommendationSchema,
    scanAt: zod_1.z.string(),
    ema: zod_1.z.number().nullish(),
    baselineEma: zod_1.z.number().nullish(),
    rating: zod_1.z.enum(enums_1.metricRatingEnum).nullish(),
    insight: zod_1.z.string().nullish(),
    imageUrl: zod_1.z.string(),
    imageQuality: exports.APIMetricDashboardDeepDiveImageQualitySchema,
    // Regional data with pre-computed landmarks (for most recent scan only)
    regionalData: zod_1.z.array(exports.APIMetricDashboardRegionalDataSchema).nullish(),
    // Image dimensions for landmark coordinate mapping (only for most recent scan)
    landmarkImageWidth: zod_1.z.number().nullish(),
    landmarkImageHeight: zod_1.z.number().nullish(),
});
exports.APIMetricDashboardDeepDiveObjectSchema = zod_1.z.object({
    techName: zod_1.z.enum(enums_1.techNameEnum),
    definition: exports.APIMetricDashboardDeepDiveDefinitionSchema,
    data: zod_1.z.array(exports.APIMetricDashboardDeepDiveValueSchema),
});
exports.APIMetricDashboardDeepDiveResponseSchema = zod_1.z.object({
    hasScannedToday: zod_1.z.boolean(),
    data: zod_1.z.array(exports.APIMetricDashboardDeepDiveObjectSchema),
    // Per-area landmark coordinates from the most recent scan's MediaPipe
    // 478-point mesh, indexed by SkinMetricAreaName. Populated as soon as
    // the FaceLandmarker stage finishes (well before regional EMA), so the
    // paywall report can render placeholder dots at each user's actual
    // facial zones while regional analysis is still running. Values are
    // optional so consumers see `Partial<Record<Area, FaceLandmark>>` —
    // not every area is guaranteed to have a landmark on every scan.
    landmarksByArea: zod_1.z
        .record(zod_1.z.enum(enums_1.areaEnum), exports.FaceLandmarkSchema.optional())
        .nullish(),
    // Image dimensions of the most recent scan, paired with landmarksByArea.
    // Mirrors the per-metric `landmarkImageWidth`/`landmarkImageHeight`
    // fields but at the response root so consumers that don't iterate the
    // metrics array (or render before regional data exists) still have the
    // numbers they need to map normalized landmarks into screen space.
    landmarkImageWidth: zod_1.z.number().nullish(),
    landmarkImageHeight: zod_1.z.number().nullish(),
});
// ===== V2: scanId-keyed deep dive (allows frontend to track selection by scan, not array index) =====
exports.APIMetricDashboardDeepDiveValueV2Schema = zod_1.z.object({
    scanId: zod_1.z.string(),
    techName: zod_1.z.enum(enums_1.techNameEnum),
    area: zod_1.z.enum(enums_1.areaEnum),
    scanRecommendation: exports.APIMetricDashboardScanRecommendationSchema,
    scanAt: zod_1.z.string(),
    ema: zod_1.z.number().nullish(), // Trend (slow EMA, gradual)
    baselineEma: zod_1.z.number().nullish(), // Baseline (long-run normal)
    emaFast: zod_1.z.number().nullish(), // Fast EMA (responsive; turns before Trend)
    rating: zod_1.z.enum(enums_1.metricRatingEnum).nullish(),
    insight: zod_1.z.string().nullish(),
    imageUrl: zod_1.z.string(),
    imageQuality: exports.APIMetricDashboardDeepDiveImageQualitySchema,
    // Regional data with pre-computed landmarks (for most recent scan only)
    regionalData: zod_1.z.array(exports.APIMetricDashboardRegionalDataSchema).nullish(),
    // Image dimensions for landmark coordinate mapping (only for most recent scan)
    landmarkImageWidth: zod_1.z.number().nullish(),
    landmarkImageHeight: zod_1.z.number().nullish(),
});
exports.APIMetricDashboardDeepDiveObjectV2Schema = zod_1.z.object({
    techName: zod_1.z.enum(enums_1.techNameEnum),
    definition: exports.APIMetricDashboardDeepDiveDefinitionSchema,
    data: zod_1.z.array(exports.APIMetricDashboardDeepDiveValueV2Schema),
});
exports.APIMetricDashboardDeepDiveResponseV2Schema = zod_1.z.object({
    hasScannedToday: zod_1.z.boolean(),
    data: zod_1.z.array(exports.APIMetricDashboardDeepDiveObjectV2Schema),
});
// ===== REGIONAL DEEP DIVE (Historical data for a specific region) =====
exports.APIMetricDashboardRegionalDeepDiveRequestSchema = zod_1.z.object({
    locale: zod_1.z.enum(enums_1.supportedLocaleEnum).optional(),
    techName: zod_1.z.enum(enums_1.techNameEnum),
    area: zod_1.z.enum(enums_1.areaEnum),
});
// Lightweight chart data for regional deep dive (only what's needed for the chart)
exports.APIMetricDashboardRegionalChartDataSchema = zod_1.z.object({
    scanAt: zod_1.z.string(),
    ema: zod_1.z.number().nullish(),
    baselineEma: zod_1.z.number().nullish(),
    insight: zod_1.z.string().nullish(),
});
exports.APIMetricDashboardRegionalDeepDiveResponseSchema = zod_1.z.object({
    techName: zod_1.z.enum(enums_1.techNameEnum),
    area: zod_1.z.enum(enums_1.areaEnum),
    data: zod_1.z.array(exports.APIMetricDashboardRegionalChartDataSchema),
});
// V2: scanId-keyed regional deep dive
exports.APIMetricDashboardRegionalChartDataV2Schema = zod_1.z.object({
    scanId: zod_1.z.string(),
    scanAt: zod_1.z.string(),
    ema: zod_1.z.number().nullish(), // Trend (slow EMA, gradual)
    baselineEma: zod_1.z.number().nullish(), // Baseline (long-run normal)
    emaFast: zod_1.z.number().nullish(), // Fast EMA (Daily; responsive, turns before Trend)
    insight: zod_1.z.string().nullish(),
});
exports.APIMetricDashboardRegionalDeepDiveResponseV2Schema = zod_1.z.object({
    techName: zod_1.z.enum(enums_1.techNameEnum),
    area: zod_1.z.enum(enums_1.areaEnum),
    data: zod_1.z.array(exports.APIMetricDashboardRegionalChartDataV2Schema),
});
// V2: lazy-loaded per-scan regional landmarks for one metric. Lets the
// deep-dive screen render landmark overlays on historical scans (not just
// the most-recent), without bloating the initial getDeepDive payload.
exports.APIMetricDashboardRegionalLandmarksRequestSchema = zod_1.z.object({
    techName: zod_1.z.enum(enums_1.techNameEnum),
    locale: zod_1.z.enum(enums_1.supportedLocaleEnum).optional(),
});
exports.APIMetricDashboardRegionalLandmarksItemSchema = zod_1.z.object({
    scanId: zod_1.z.string(),
    scanAt: zod_1.z.string(),
    landmarkImageWidth: zod_1.z.number().nullish(),
    landmarkImageHeight: zod_1.z.number().nullish(),
    regionalData: zod_1.z.array(exports.APIMetricDashboardRegionalDataSchema),
});
exports.APIMetricDashboardRegionalLandmarksResponseSchema = zod_1.z.object({
    techName: zod_1.z.enum(enums_1.techNameEnum),
    data: zod_1.z.array(exports.APIMetricDashboardRegionalLandmarksItemSchema),
});
// ===== SCAN INSIGHTS (Lightweight endpoint for scan-overview) =====
exports.APIScanInsightsRequestSchema = zod_1.z.object({
    scanId: zod_1.z.string(),
    techNames: zod_1.z.array(zod_1.z.enum(enums_1.techNameEnum)),
    locale: zod_1.z.enum(enums_1.supportedLocaleEnum).optional(),
});
exports.APIScanInsightsMetricSchema = zod_1.z.object({
    techName: zod_1.z.enum(enums_1.techNameEnum),
    value: zod_1.z.union([zod_1.z.number(), zod_1.z.string()]).nullable(), // EMA for numeric, category string for categorical
    patientNote: zod_1.z.string().nullable(), // LLM-generated observation from skin_metric
    insight: zod_1.z.string().nullable(), // Stage-based insight from metric detail
});
exports.APIScanInsightsResponseSchema = zod_1.z.object({
    metrics: zod_1.z.array(exports.APIScanInsightsMetricSchema),
});
// ===== MINI REPORT (Lightweight endpoint for mini-report observations) =====
exports.APIMiniReportRequestSchema = zod_1.z.object({
    scanId: zod_1.z.string(),
    techNames: zod_1.z.array(zod_1.z.enum(enums_1.techNameEnum)),
    locale: zod_1.z.enum(enums_1.supportedLocaleEnum).optional(),
});
exports.APIMiniReportMetricSchema = zod_1.z.object({
    techName: zod_1.z.enum(enums_1.techNameEnum),
    value: zod_1.z.union([zod_1.z.number(), zod_1.z.string()]).nullable(),
    rating: zod_1.z.enum(enums_1.metricRatingEnum).nullable(),
    goalWeight: zod_1.z.number().nullable(),
    patientNote: zod_1.z.string().nullable(),
    insight: zod_1.z.string().nullable(),
});
exports.APIMiniReportResponseSchema = zod_1.z.object({
    metrics: zod_1.z.array(exports.APIMiniReportMetricSchema),
});
//# sourceMappingURL=metric_dashboard.js.map